import { useHistoryInterceptor } from '@helpers/history';
import { IconX } from '@tabler/icons-react';
import ReactModal from 'react-modal';

interface ModalProps {
  onRequestClose?: () => void;
  children?: React.ReactNode;
  isOpen?: boolean;
  title?: string;
}

export function Modal({ title, isOpen, children, onRequestClose }: ModalProps) {
  useHistoryInterceptor(() => {
    if (isOpen) { onRequestClose?.(); return true; }
    return false;
  }, { disabled: !isOpen });

  return (
    // @ts-ignore
    <ReactModal
      onRequestClose={onRequestClose}
      isOpen={isOpen ?? false}
      ariaHideApp={false}
    >
      <div className="modal-body">
        <div className="flex bg-gray-900 border-b border-secondary sticky top-0 left-0 right-0 z-20">
          <div className="border-r border-secondary flex-1 p-1 px-2">
            <p className="text-lg">{title}</p>
          </div>
          <button className="p-2.5 flex items-center justify-center" onClick={onRequestClose}>
            <IconX size={14} />
          </button>
        </div>

        {children}
      </div>
    </ReactModal>
  );
}